export default "__VITE_ASSET__Bof7Dnc8__"